import type { DataTableColumnPinningSettingsProps } from './column-settings-types.js';

/**
 * The slot component serves the sole purpose of detecting the user's intention
 * to display column pinning within the column settings modal, situated in the DataTable toolbar.
 * @public
 */
export const DataTableColumnPinningSettings = ({
  resetColumnPinning,
}: DataTableColumnPinningSettingsProps) => null;

DataTableColumnPinningSettings.displayName = 'DataTable.ColumnPinningSettings';
